import { GetProgramTopoHole } from './get-program-topo-hole.model';

export class GetProgramTopoArea {
    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            // Lynx Cloud API sometimes uses PascalCase and sometimes camelCase
            // Lynx Drive API uses camelCase
            this.id = json.Id ?? json.id;
            this.name = json.Name ?? json.name;
            this.holes = json?.Holes?.map(h => new GetProgramTopoHole(h)) ?? json?.holes.map(h => new GetProgramTopoHole(h));

            delete this['Id'];
            delete this['Name'];
            delete this['Holes'];
        }
    }

    id: number;
    name: string;
    holes: GetProgramTopoHole[];
}
